import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";

function BlogDetails() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBlog = async () => {
      try {
        const response = await fetch(
          "https://mimagtech.com/bombaydentalcompany/bombaydentalcompanyapi/temp.php"
        );
        const data = await response.json();

        if (data && data.data) {
          const foundBlog = data.data.find((blog) => blog.id === parseInt(id));
          if (foundBlog) {
            setBlog(foundBlog);
          } else {
            setError(new Error("Blog not found"));
          }
        }
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    fetchBlog();
  }, [id]);

  if (loading)
    return (
      <div style={{ textAlign: "center", padding: "2rem" }}>Loading...</div>
    );
  if (error)
    return (
      <div style={{ textAlign: "center", padding: "2rem", color: "red" }}>
        Error: {error.message}
      </div>
    );
  if (!blog)
    return (
      <div style={{ textAlign: "center", padding: "2rem" }}>Blog not found</div>
    );

  return (
    <div
      style={{
        maxWidth: "1200px",
        margin: "0 auto",
        padding: "2rem",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <button
        onClick={() => navigate("/blog")}
        style={{
          padding: "0.5rem 1rem",
          marginBottom: "2rem",
          backgroundColor: "#007bff",
          color: "white",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer",
        }}
      >
        ← Back to Blogs
      </button>

      <img
        src={blog.image || "placeholder.jpg"}
        alt={blog.title}
        style={{
          width: "100%",
          height: "400px",
          objectFit: "cover",
          borderRadius: "8px",
          marginBottom: "2rem",
        }}
      />

      <div style={{ marginBottom: "1rem" }}>
        <span
          style={{
            backgroundColor: "#e9ecef",
            padding: "0.25rem 0.5rem",
            borderRadius: "4px",
            fontSize: "0.9rem",
            marginRight: "1rem",
          }}
        >
          {blog.category || "Uncategorized"}
        </span>
        <span style={{ color: "#6c757d", fontSize: "0.9rem" }}>
          {new Date(blog.date).toLocaleDateString()}
        </span>
      </div>

      <h1
        style={{
          fontSize: "2.5rem",
          marginBottom: "1.5rem",
          color: "#333",
        }}
      >
        {blog.title}
      </h1>

      <div
        style={{
          lineHeight: "1.8",
          color: "#444",
          whiteSpace: "pre-wrap",
        }}
      >
        {blog.description}
      </div>
    </div>
  );
}

export default BlogDetails;
